import { Base } from '@studiometa/js-toolkit';

/**
 *  component
 */
export default class Presse extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Presse',
    refs: ['tag[]', 'post[]'],
  };

  /**
   *
   * @param {*} param0
   */
  onTagClick({ target }) {
    const tagFilter = target.dataset.tagName;

    // Si un tag est actif
    if (target.classList.contains('is-active')) {
      // Remove de la class inactive
      this.$refs.tag.forEach((item) => {
        item.classList.remove('is-inactive');
      });
      target.classList.remove('is-active');

      // Affichage de tous les posts
      this.$refs.post.forEach((item) => {
        item.classList.remove('hidden');
      });
    } else {
      // Ajout des classes inactives
      this.$refs.tag.forEach((item) => {
        item.classList.remove('is-active');
        item.classList.add('is-inactive');
      });
      target.classList.add('is-active');
      target.classList.remove('is-inactive');

      // Tri des posts
      this.$refs.post.forEach((item) => {
        if (item.dataset.tag !== tagFilter) {
          item.classList.add('hidden');
        } else {
          item.classList.remove('hidden');
        }
      });
    }
  }
}
